module.exports = __webpack_public_path__ + "static/img/4.38caeb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/commonality/20240725/4.jpg
// module id = LJQn
// module chunks = 7